export default __webpack_public_path__ + "static/media/NR-BX421GUS03.d479f172.jpg";